import { Link } from "@tanstack/react-router";

import type { ContentItem } from "@/content/types";
import { SmartImage } from "@/components/site/SmartImage";
import type { ResponsiveImage } from "@/lib/responsive-images";

export type SportCard = { to: string; image: ResponsiveImage; alt: string };

/** Tre idrottsprofiler som kort med bild och länk vidare. */
export function SportProfiles({
  items,
  cards,
  linkLabel,
}: {
  items: ContentItem[];
  cards: SportCard[];
  linkLabel: string;
}) {
  if (items.length === 0) return null;

  return (
    <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
      {items.map((item, i) => {
        const card = cards[i];
        if (!card) return null;
        return (
          <Link
            key={item.title}
            to={card.to as never}
            className="group overflow-hidden rounded-xl border border-border bg-card shadow-soft transition-colors hover:border-primary/40"
          >
            <SmartImage
              image={card.image}
              alt={card.alt}
              width={1024}
              height={683}
              sizes="(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw"
              className="h-44 w-full object-cover"
            />
            <div className="p-6">
              <h3 className="text-base font-semibold">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{item.text}</p>
              <span className="mt-4 inline-block text-sm text-primary group-hover:underline">
                {linkLabel}
              </span>
            </div>
          </Link>
        );
      })}
    </div>
  );
}
